export const SUBSCRIPTION_PLANS = [
  {
    id: 'essential',
    duration: '1 Month',
    badge: 'Fast start',
    price: 149,
    priceLabel: '149',
    period: '/month',
    originalPrice: 'Rs 299',
    features: [
      'Priority rooms access',
      'Unlimited subscriber chats',
      'Core search filters',
      'Text feedback support',
    ],
    buttonLabel: 'Choose Starter',
    featured: false,
    active: false,
    enabled: false,
  },
  {
    id: 'advance',
    duration: '6 Months',
    badges: ['Active Plan', 'Most Popular'],
    price: 599,
    priceLabel: '599',
    period: '/6 months',
    originalPrice: 'Rs 1,194',
    features: [
      'Everything in Starter',
      'Faster room discovery',
      'Advanced filters & alerts',
      'WhatsApp priority support',
    ],
    buttonLabel: 'Claim Launch Offer',
    featured: true,
    active: true,
    enabled: true,
  },
  {
    id: 'expert',
    duration: '1 Year',
    badge: 'Best savings',
    price: 999,
    priceLabel: '999',
    period: '/year',
    originalPrice: 'Rs 2,388',
    features: [
      'Everything in Growth',
      'Dedicated support line',
      'Premium host matching',
      'Early access to new features',
    ],
    buttonLabel: 'Upgrade to Pro',
    featured: false,
    active: false,
    enabled: false,
  },
];

export const SUBSCRIPTION_POLICIES = [
  {
    title: 'Straightforward billing',
    lines: ['Clear pricing with no hidden fees.', 'See your renewal date anytime.'],
  },
  {
    title: 'Cancel anytime',
    lines: ['No long lock-ins on monthly plans.', 'Turn off auto-renewal in one click.'],
  },
  {
    title: 'Fair renewal pricing',
    lines: ['Longer plans save more per month.', 'Launch offer applied at checkout.'],
  },
  {
    title: 'Secure checkout',
    lines: ['Encrypted payments via trusted gateways.', 'Your card details stay protected.'],
  },
];

export const LAUNCH_OFFER_FINAL_PRICE = 0;

export const getPlanById = (id) =>
  SUBSCRIPTION_PLANS.find((p) => p.id === id) || SUBSCRIPTION_PLANS[1];

export const getLaunchDiscountPercent = (plan) => {
  if (!plan?.price) return 100;
  return Math.round(((plan.price - LAUNCH_OFFER_FINAL_PRICE) / plan.price) * 100);
};
